module.exports = __webpack_public_path__ + "20230117/img/slide1_app.8282eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1_app.png
// module id = pGZM
// module chunks = 1